import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-muted/20 p-4">
      <Card className="max-w-2xl w-full">
        <CardContent className="pt-12 pb-8 px-6 text-center">
          {/* 404 Number */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary/20 select-none">404</h1>
          </div>

          {/* Icon */}
          <div className="mb-6 flex justify-center">
            <div className="bg-muted rounded-full p-6">
              <Search className="h-12 w-12 text-muted-foreground" />
            </div>
          </div>

          {/* Title and Description */}
          <div className="space-y-3 mb-8">
            <h2 className="text-3xl font-bold tracking-tight">Sidan hittades inte</h2>
            <p className="text-muted-foreground text-lg max-w-md mx-auto">
              Tyvärr kunde vi inte hitta sidan du letar efter. Den kan ha flyttats eller så finns den inte längre.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              onClick={() => navigate(-1)}
              variant="outline"
              size="lg"
              className="w-full sm:w-auto"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Gå tillbaka
            </Button>
            <Button
              onClick={() => navigate('/')}
              size="lg"
              className="w-full sm:w-auto"
            >
              <Home className="mr-2 h-4 w-4" />
              Till startsidan
            </Button>
          </div>
          
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
